import {OrderMethodsRequest, OrderMethodsResponse} from '../../../../models/api/back/create-order/order-methods';
import {AppThunk, store} from "../../../../app/store";
import {ordersDataActions} from "../../../../slices/orders/orders-data-slice";
import {apiActions} from "../../../../slices/api-slice";
import {ResponseBase} from "../../../response-base";
import {ApiBaseBack} from "../../api-base-back";
import { ordersActions } from '../../../../slices/orders-slice';
import { ApiOrderOrderStyle } from '../order-style/api-order-style.back';
import { CustomError } from '../../../../models/custom-error';

export class ApiOrderMethods extends ApiBaseBack<OrderMethodsResponse> {
  constructor(param: OrderMethodsRequest) {
    super(
      'GET',
      '/api/v1/orderMethods',
      'JSON',
      param,
    );
  }
}

export const apiOrderMethodsThunk = (param: OrderMethodsRequest, callback: () => void, isInit: boolean, agent: boolean, getOrderStyle?: boolean): AppThunk => async (dispatch, getState) => {
  if (!param.productNameId) {
    dispatch(ordersDataActions.updateItemDetail({
      orderMethods: { orderMethod: [] },
      orderStyles: { orderStyleGroup: undefined },
    }));
    callback?.();
    return;
  }
  dispatch(apiActions.run(
    new ApiOrderMethods(param),
    {
      onSuccess: (res: ResponseBase<OrderMethodsResponse>) => {
        callback?.();
        if (!isInit && param.productNameId !== getState().order.itemDetail.itemSelect.value) {
          return;
        }
        if (getOrderStyle) {
          try {
            new ApiOrderOrderStyle({ productNameId: param.productNameId, kijshopCd: getState().storage.staffInfo.kijshopCd }).do().then((res) => {
              if (!(res instanceof CustomError)) {
                dispatch(ordersDataActions.updateItemDetail({
                  orderStyles: res.body.data ?? { orderStyleGroup: [] },
                }));
                const purpose = getState().order.itemDetail.purpose;
                if (purpose && res.body.data?.orderStyleGroup?.find((v) => v.orderStyleGroupID === purpose.value)) {
                  dispatch(ordersActions.itemDetail.setPurpose(purpose));
                } else {
                  dispatch(ordersActions.itemDetail.setPurpose(undefined));
                }
              }
            }).finally(() => {})
          } catch(e) {}
        }

        dispatch(ordersDataActions.updateItemDetail({
          orderMethods: { orderMethod: res.body.data?.orderMethod || [] },
        }));
        const orderMethod = getState().order.itemDetail.orderMethod;
        if (orderMethod.value && res.body.data?.orderMethod?.find((v) => v.orderMethodId === orderMethod.value)) {
          dispatch(ordersActions.itemDetail.setOrderMethod(orderMethod.value, orderMethod.label, agent));
        }
      },
      onError: () => {
        dispatch(ordersDataActions.updateItemDetail({
          orderMethods: { orderMethod: [] },
          orderStyles: { orderStyleGroup: undefined }
        }));
        callback?.();
      },
    },
    {
      apiName: 'order-methods',
      ignoreSystemError: true,
    },
  ))
};
